import ArchetypeMystic from './ArchetypeMystic'

export default ArchetypeMystic
// eslint-disable-next-line import/export
export * from './ArchetypeMystic'
